import { useQuery } from "@tanstack/react-query";
import { membershipApi } from "@bw/shared/api";
import type { VenuePlanResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A facility's ACTIVE, player-facing membership/visit plans (GET
 * /facilities/{id}/plans → VenuePlanResponse[]). The backend returns only
 * purchasable plans; the catalog renders them in server order. Gated on a truthy
 * facilityId.
 */
export function useFacilityPlans(facilityId: string | undefined) {
  return useQuery<VenuePlanResponse[]>({
    queryKey: queryKeys.memberships.facilityPlans(facilityId ?? ""),
    queryFn: () => membershipApi.listFacilityPlans(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
